angular.module('myApp.services')
    .factory('recordMediaStream', ['$rootScope', 'clientTools', 'speechRecognitionManager', '$http',
        'user', 'audioVideoResponse', 'audioSensitivity', 'userMediaStream', 'tokensStorage',
        function($rootScope, clientTools, speechRecognitionManager, $http, user, audioVideoResponse,
                 audioSensitivity, userMediaStream, tokensStorage) {
            let isLog                           = false;
            let timeInterval                    = 5;    //in seconds
            let recordTime                      = {     //in seconds
                'max'   : 60,
                'min'   : 15
            };
            let speechRecorderFileDuration      = 20;
            let mediaRecorders                  = {};
            let speechRecorders                 = {};
            let recordedFiles                   = {};
            let recordingStatus                 = {};
            let sendFileProgress                = {};
            let isUserPartialUploading          = true;     //If true we will slice uploaded file according to bandwidth and PartialUploadLimits
            let partialUploadLimits             = [
                {
                    'limit': 0.5,           //upload speed in mb, see clientTools.getInternetSpeed()
                    'partSize': 100000
                },
                {
                    'limit': 1,
                    'partSize': 200000
                },
                {
                    'limit': 2,
                    'partSize': 500000
                },
                {
                    'limit': 100,
                    'partSize': 10000000
                }
            ];
            const dataUrl = clientTools.getNodeJsHost() + '/user-media-files';

            const sendFileStatuses = {
                'inactive'  : 'inactive',
                'progress'  : 'progress',
                'done'      : 'done',
                'failed'    : 'failed'
            };

            const emitFiles = function(data) {
                if (data) {
                    data.userId             = user.getUserId();
                    let partNum             = data.partNum;
                    let qId                 = data.qId;
                    log("Send request for " + partNum + ". Parts count = " + data.partsCount);
                    $http.post(
                        dataUrl,
                        data,
                        {
                            headers: {'Authorization': 'Bearer ' + tokensStorage.getToken()},
                            cache: false
                        }
                    )
                    .then(function(response) {
                        let responseData    = response.data;
                        log("Got response for " + partNum + ". Response data: ", responseData);
                        let status          = responseData.status;
                        let message         = responseData.message;
                        let files           = responseData.data;
                        if (status == 1) {
                            sendFileProgress[qId][partNum] = sendFileStatuses.done;
                            if ((('video' in files) && files.video.length) || (('audio' in files) && files.audio.length)) {
                                recordedFiles[qId] = files;
                            }
                        } else {
                            sendFileProgress[qId][partNum] = sendFileStatuses.failed;
                            if ('audioLevel' in responseData.data) {
                                audioSensitivity.checkCurrentAudioLevel(qId, responseData.data.audioLevel);
                            } else {
                                userMediaStream.setUserMediaError(message, qId);
                            }
                            log(message);
                        }
                        updateSendFileProgress(qId);
                    }, function(response) {
                        log("Got Failed response " + partNum);
                        sendFileProgress[qId][partNum] = sendFileStatuses.failed;
                        updateSendFileProgress(qId);
                    });
                }
            };
            const clearBufferOnServer = function (data) {
                if (data && ('qId' in data)) {
                    data.userId = user.getUserId();
                    $http.post(
                        dataUrl,
                        data,
                        {
                            headers: {'Authorization': 'Bearer ' + tokensStorage.getToken()},
                            cache: false
                        }
                    ).then(function(response) {}, function(response) {});
                }
            };
            const getDataUrl = function(blob, recordingState, type, qId) {
                sendFileProgress[qId].push(sendFileStatuses.progress);
                var partNum     = sendFileProgress[qId].length - 1;
                var partsCount  = recordingState == 'inactive' ? sendFileProgress[qId].length : 0;
                updateSendFileProgress(qId);

                var reader      = new FileReader();
                reader.onload   = function(event) {
                    var dataURL     = event.target.result;
                    var recFiles    = {};
                    recFiles[type]  = {'type': blob.type, 'dataURL': dataURL};
                    var toEmit = {
                        'qId'           : parseInt(qId),
                        'files'         : recFiles,
                        'partNum'       : partNum,
                        'partsCount'    : partsCount
                    };
                    log("Blob size = " + blob.size);
                    emitFiles(toEmit);
                };
                reader.onerror = function(e) {
                    sendFileProgress[qId][partNum] = sendFileStatuses.failed;
                    updateSendFileProgress(qId);
                    log("Cann't read blob to data url: " + e.getMessage());
                };
                reader.readAsDataURL(blob);
            };

            var updateSendFileProgress = function(qId) {
                var sendFileStatus = sendFileStatuses.inactive;
                if (recordingStatus[qId] == audioVideoResponse.recordStopped) {
                    var isAnyPartInProgress = false;
                    var isAnyPartFailed     = false;
                    for (var partNum = 0; partNum < sendFileProgress[qId].length; partNum++) {
                        if (sendFileProgress[qId][partNum] == sendFileStatuses.progress) {
                            isAnyPartInProgress = true;
                            break;
                        } else if (sendFileProgress[qId][partNum] == sendFileStatuses.failed) {
                            isAnyPartFailed = true;
                        }
                    }
                    if (isAnyPartInProgress) {
                        sendFileStatus = sendFileStatuses.progress;
                    } else if (isAnyPartFailed) {
                        sendFileStatus = sendFileStatuses.failed;
                    } else {
                        if (('video' in recordedFiles[qId] && recordedFiles[qId].video.length) ||
                            (('audio' in recordedFiles[qId]) && recordedFiles[qId].audio.length)) {
                            sendFileStatus = sendFileStatuses.done;
                        } else {
                            sendFileStatus = sendFileStatuses.failed;
                        }
                    }
                }

                $rootScope.$broadcast("recordedFilesProgress", {'status' : sendFileStatus, 'qId': qId});
            };
            var initRecorder = function(stream, type, questionId) {
                var options = {'mimeType': 'video/webm'};
                if (type == 'audio') {
                    options.mimeType  = 'audio/ogg';
                }
                try {
                    mediaRecorders[questionId][type] = new MediaRecorder(stream, options);
                } catch (e) {
                    mediaRecorders[questionId][type] = new MediaRecorder(stream);
                }
                mediaRecorders[questionId][type].ondataavailable = function(e) {
                    if (e.data && e.data.size/* && e.data.size > 26800*/ && mediaRecorders[questionId][type]) {
                        //console.log(e.data.size, mediaRecorders[questionId][type].state);
                        /**
                         * recording state active or inactive
                         */
                        getDataUrl(e.data, mediaRecorders[questionId][type].state, type, questionId);
                    }
                    e.stopPropagation();
                    return false;
                };
                mediaRecorders[questionId][type].onstop = function(e) {
                    mediaRecorders[questionId][type] = null;
                };
                mediaRecorders[questionId][type].onerror = function(error) {
                    if (error.name === 'InvalidState') {
                        console.error('The MediaRecorder is not in a state in which the proposed operation is allowed to be executed.');
                    } else if (error.name === 'OutOfMemory') {
                        console.error('The UA has exhaused the available memory. User agents SHOULD provide as much additional information as possible in the message attribute.');
                    } else if (error.name === 'IllegalStreamModification') {
                        console.error('A modification to the stream has occurred that makes it impossible to continue recording. An example would be the addition of a Track while recording is occurring. User agents SHOULD provide as much additional information as possible in the message attribute.');
                    } else if (error.name === 'OtherRecordingError') {
                        console.error('Used for an fatal error other than those listed above. User agents SHOULD provide as much additional information as possible in the message attribute.');
                    } else if (error.name === 'GenericError') {
                        console.error('The UA cannot provide the codec or recording option that has been requested.', error);
                    } else {
                        console.error('MediaRecorder Error', error);
                    }

                    if (!! mediaRecorders[questionId][type] &&  mediaRecorders[questionId][type].state !== 'inactive'
                        &&  mediaRecorders[questionId][type].state !== 'stopped') {
                        mediaRecorders[questionId][type].stop();
                    }
                };
                try {
                    mediaRecorders[questionId][type].start(3.6e+6);
                } catch (e) {
                    console.log("Error when start media recorder: ", e.message);
                }
            };
            var initSpeechRecorder = function(stream, questionId, videoEl) {
                if (!(questionId in speechRecorders) && speechRecognitionManager.isRecognizeSpeech()) {
                    speechRecorders[questionId]                 = new MediaStreamRecorder(stream, {'type':'audio'});
                    speechRecorders[questionId].audioChannels   = 1;
                    speechRecorders[questionId].video           = videoEl;
                    //speechRecorders[questionId].mimeType        = 'audio/pcm';
                    speechRecorders[questionId].recorderType    = StereoAudioRecorder;
                    speechRecorders[questionId].ondataavailable = function(blob) {
                        var reader      = new FileReader();
                        reader.onload = function(event) {
                            var url     = event.target.result;
                            var toEmit  = {
                                'type'      : blob.type,
                                'qId'       : questionId,
                                'dataURL'   : url
                            };
                            speechRecognitionManager.emitFileToRecognize(toEmit);
                        };
                        reader.readAsDataURL(blob);
                    };
                    speechRecorders[questionId].start(speechRecorderFileDuration*1000);     //Send recorded speech to server for future speech recognition
                }
            };
            var log = function (message, data) {
                if (isLog) {
                    if (data) {
                        console.info(message, data);
                    } else {
                        console.info(message);
                    }

                }
            };

            return {
                startRecording: function(stream, type, questionId, videoEl) {
                    questionId = parseInt(questionId);
                    if (!(questionId in mediaRecorders)) {
                        mediaRecorders[questionId] = {
                            'audio': null,
                            'video': null
                        };
                    }
                    recordedFiles[questionId]       = {'audio': [], 'video': [], 'image': [], 'duration': []};
                    sendFileProgress[questionId]    = [];
                    if (stream && type && questionId && videoEl) {

                        initRecorder(stream, type, questionId);
                        initSpeechRecorder(stream, questionId, videoEl);

                        this.setRecordingStatus(questionId, audioVideoResponse.recordActive);
                    }
                },
                requestRecordedData: function(qId, type) {
                    if (mediaRecorders[qId][type] && ('requestData' in  mediaRecorders[qId][type])) {
                        mediaRecorders[qId][type].requestData();
                    }
                },
                resetRecorders: function(qId) {
                    if (qId in speechRecorders) {
                        delete speechRecorders[qId];
                    }
                    if (qId in mediaRecorders) {
                        for (var type in mediaRecorders[qId]) {
                            mediaRecorders[qId][type]   = null;
                        }
                    }
                    recordedFiles[qId]    = {'audio': [], 'video': [], 'image': [], 'duration': []};
                    sendFileProgress[qId] = [];
                    this.setRecordingStatus(qId, audioVideoResponse.recordNotActive);
                    clearBufferOnServer({'qId': qId});
                },
                sendFileOrBlob : function(file, type, qId) {
                    if (file) {
                        if (isUserPartialUploading) {
                            var partSize    = partialUploadLimits[1].partSize;  //size in bytes of one part of the file
                            var bandwidth   = clientTools.getInternetSpeed().upload;
                            if (bandwidth > 0) {
                                for (var i = 0; i < partialUploadLimits.length; i++) {
                                    if (bandwidth < partialUploadLimits[i].limit) {
                                        partSize = partialUploadLimits[i].partSize;
                                        break;
                                    }
                                }
                            }
                            var fileSize = file.size;
                            var fileType = file.type;
                            sendFileProgress[qId]    = [];
                            if (fileSize > partSize) {
                                var blobParts   = [];
                                var startByte   = 0;
                                var endByte     = 0;
                                var countParts  = Math.ceil(fileSize / partSize);
                                for (var i = 0; i < countParts; i++) {
                                    if (endByte == 0) {
                                        endByte = startByte + partSize;
                                    }
                                    var partBlob = new Blob([]);
                                    if (file.slice) {
                                        partBlob = file.slice(startByte, endByte, fileType);
                                    }
                                    if (partBlob.size) {
                                        blobParts.push(partBlob);
                                        startByte = endByte;
                                        endByte = startByte + partSize;
                                        if (endByte > fileSize) {
                                            endByte = fileSize;
                                        }
                                    }
                                }

                                //Some logic of sending parts here
                                for (var i = 0; i < blobParts.length; i++) {
                                    var status = (i == countParts - 1) ? 'inactive' : 'active';
                                    getDataUrl(blobParts[i], status, type, qId);
                                }
                            } else {
                                getDataUrl(file, 'inactive', type, qId);
                            }
                        } else {
                            getDataUrl(file, 'inactive', type, qId);
                        }
                    }
                },
                stopRecording: function(qId) {
                    if (qId in speechRecorders) {
                        speechRecorders[qId].stop();
                        delete speechRecorders[qId];
                    }
                    if (qId in mediaRecorders) {
                        for (var type in mediaRecorders[qId]) {
                            if (mediaRecorders[qId][type]) {
                                mediaRecorders[qId][type].stop();
                            }
                        }
                    }
                    this.setRecordingStatus(qId, audioVideoResponse.recordStopped);
                },
                pauseRecording: function(qId) {
                    if (qId in speechRecorders) {
                        speechRecorders[qId].pause();
                    }
                    if (qId in mediaRecorders) {
                        for (var type in mediaRecorders[qId]) {
                            if (mediaRecorders[qId][type]) {
                                mediaRecorders[qId][type].pause();
                            }
                        }
                        this.setRecordingStatus(qId, audioVideoResponse.recordPaused);
                    }
                },
                resumeRecording: function(qId) {
                    if (qId in speechRecorders) {
                        speechRecorders[qId].resume();
                    }
                    if (qId in mediaRecorders) {
                        for (var type in mediaRecorders[qId]) {
                            if (mediaRecorders[qId][type]) {
                                mediaRecorders[qId][type].resume();
                            }
                        }
                        this.setRecordingStatus(qId, audioVideoResponse.recordActive);
                    }
                },
                getRecordedFiles: function(qId) {
                    if (!(qId in recordedFiles)) {
                        recordedFiles[qId] = {'audio': [], 'video': [], 'image': [], 'duration': []};
                    }
                    return recordedFiles[qId];
                },
                setRecordingStatus: function (qId, status) {
                    qId = parseInt(qId);
                    if (!(qId in recordingStatus)) {
                        recordingStatus[qId] = audioVideoResponse.recordNotActive;
                    }
                    recordingStatus[qId] = status;
                    $rootScope.$broadcast("recordingStatusChanged", {'qId': qId});
                },
                getRecordingStatus: function (qId) {
                    qId = parseInt(qId);
                    if (qId in recordingStatus) {
                        return recordingStatus[qId];
                    }
                    return recordingStatus[qId] = audioVideoResponse.recordNotActive;
                },
                isRecordingInProgress: function () {
                    for (var qId in recordingStatus) {
                        if (recordingStatus[qId] == audioVideoResponse.recordActive
                            || recordingStatus[qId] == audioVideoResponse.recordPaused) {
                            return true;
                        }
                    }
                    return false;
                },
                isSendingRecordedFileInProgress: function () {
                    for (var qId in sendFileProgress) {
                        for (var partNum = 0; partNum < sendFileProgress[qId].length; partNum++) {
                            if (sendFileProgress[qId][partNum] == sendFileStatuses.progress) {
                                return true;
                            }
                        }
                    }
                    return false;
                },
                setRecordTime: function (max, min) {
                    max = parseInt(max);
                    min = parseInt(min);
                    if (max > min) {
                        recordTime.max = max;
                        recordTime.min = min;
                    }
                },
                getRecordTime: function () {
                    return recordTime;
                },
                timeInterval: timeInterval,
                sendFileStatuses: sendFileStatuses
            }
        }]);